export default __webpack_public_path__ + "static/6654-f36dfd93fcd39e87198ef9cd6e4b3c4b.jpg";